import memoize from 'transmute/memoize';
export const getFlattenedProperties = memoize(propertiesByGroup => propertiesByGroup.flatMap(group => group.properties));